import { createBrowserRouter } from "react-router-dom";
import GameStatsPage from "./pages/gameStatsPage";
import App from './App';
import TimerPage from "./pages/timerPage";
import ReplyPage from "./pages/replyPage";

export const router = createBrowserRouter([
  {
    path: "/timer",
    element: <TimerPage />
  },
  {
    path: "/scoreboard",
    element: (
      <div className="App">
        <div className="header">
          <GameStatsPage />
        </div>
      </div>
    ),
  },
  {
    path: "/reply",
    element: <ReplyPage />,
  },
  {
    path: "/",
    element: <App/>
  },
]);